import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    LabelPricing,
    PlanHeaderRow,
    PlanName,
    MostPopularBadge,
    PlanPrice,
    PlanDescription,
    IncludedBlock,
    IncludedRow,
    CheckmarkIconSlot,
    IncludedText,
} from 'vendor/components/Webstore/PickYourPlanSection/PearlConnectPlanTile.styled';
import { PearlConnectPlanCheckmark } from 'vendor/components/Webstore/PickYourPlanSection/PearlConnectPlanCheckmark';
import {
    SignaturePlanCard,
    SignatureIconContainer,
    SignatureCardBody,
    SignatureLeadIn,
    SignatureTagline,
    SignatureCtaButton,
} from './SignaturePlanTile.styled';

const SignaturePlanTile = ({
    planKey,
    icon,
    iconBackground,
    priceLabel,
    isSelected = false,
    isPriceLoading = false,
    isBusy = false,
    onChoose,
}) => {
    const { t } = useTranslation();
    const base = `SignaturePlans.Plans.${planKey}`;
    const name = t(`${base}.Name`);
    const badge = t(`${base}.Badge`, { defaultValue: '' });
    const leadIn = t(`${base}.LeadIn`, { defaultValue: '' });
    const benefits = t(`${base}.Benefits`, { returnObjects: true });

    return (
        <SignaturePlanCard data-testid={`signature-plan-${planKey}`} $isSelected={isSelected}>
            <SignatureIconContainer $background={iconBackground}>
                <img src={icon} alt="" />
            </SignatureIconContainer>
            <SignatureCardBody>
                <LabelPricing>
                    <PlanHeaderRow>
                        <PlanName>{name}</PlanName>
                        {badge ? <MostPopularBadge>{badge}</MostPopularBadge> : null}
                    </PlanHeaderRow>
                    <PlanPrice data-testid={`signature-plan-${planKey}-price`}>
                        {isPriceLoading ? '' : priceLabel}
                    </PlanPrice>
                    <SignatureTagline>{t(`${base}.Tagline`)}</SignatureTagline>
                    <PlanDescription>{t(`${base}.Description`)}</PlanDescription>
                </LabelPricing>
                <IncludedBlock>
                    {leadIn ? (
                        <IncludedRow>
                            <CheckmarkIconSlot>
                                <PearlConnectPlanCheckmark />
                            </CheckmarkIconSlot>
                            <SignatureLeadIn>{leadIn}</SignatureLeadIn>
                        </IncludedRow>
                    ) : null}
                    {(Array.isArray(benefits) ? benefits : []).map((line) => (
                        <IncludedRow key={`${planKey}-${line}`}>
                            <CheckmarkIconSlot>
                                <PearlConnectPlanCheckmark />
                            </CheckmarkIconSlot>
                            <IncludedText>{line}</IncludedText>
                        </IncludedRow>
                    ))}
                </IncludedBlock>
            </SignatureCardBody>
            {/* CTA label and behavior are not confirmed yet; `onChoose` is supplied by the page. */}
            <SignatureCtaButton
                type="button"
                $variant="primary"
                disabled={isSelected || isBusy}
                onClick={() => onChoose?.(planKey)}
            >
                {isSelected
                    ? t('SignaturePlans.SelectedCta')
                    : t('SignaturePlans.ChooseCta', { plan: name })}
            </SignatureCtaButton>
        </SignaturePlanCard>
    );
};

export default SignaturePlanTile;
